import React from 'react';
import { PropTypes } from 'prop-types';
import TextInput from '../FormInputs/TextInput/TextInput';
import TextArea from '../FormInputs/TextArea/TextArea';
import CustomSelect from '../FormInputs/CustomSelect/CustomSelect';
import { SITE_STATES } from '../../constants/sites';

const MainInputs = ({
  contactData, setContactData, isNameValid, setIsNameValid, errorMessage,
}) => {
  return (
    <main className="mt-8 px-5.5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9.5 mb-5.5">
        <div className="w-full text-left">
          <TextInput
            label="Name"
            name="name"
            asteriskWidth="w-2"
            value={contactData.name || ''}
            setValue={(value) => {
              setIsNameValid(true);
              setContactData((prev) => ({ ...prev, name: value }));
            }}
            isRequired
            isValid={isNameValid}
            placeholder="enter name"
            inputHeight="h-8"
            errorMessage={errorMessage?.name}
          />
        </div>

        <div className="w-full">
          <CustomSelect
            options={[
              { label: 'Grower', value: 'Grower' },
              { label: 'Contractor', value: 'Contractor' },
              { label: 'Worker', value: 'Worker' },
              { label: 'Partner Organization', value: 'Partner Organization' },
              { label: 'School/Daycare', value: 'School/Daycare' },
              { label: 'Other', value: 'Other' },
            ]}
            label="Type"
            name="type"
            spaceY="space-y-2"
            labelClassName="font-medium"
            value={contactData.contact_type}
            setValue={(value) => {
              setContactData((prev) => ({ ...prev, contact_type: value.value }));
            }}
            placeholder="select contact type"
          />
        </div>
      </div>
      <div className="space-y-5.5 pb-5.5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9.5">
          <TextInput
            label="Company"
            name="company"
            value={contactData.company}
            setValue={(value) => setContactData((prev) => ({ ...prev, company: value }))}
            placeholder="enter company"
            inputHeight="h-8"
          />
          <div />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9.5">
          <TextInput
            label="Phone"
            name="phone"
            value={contactData.phone}
            setValue={(value) => setContactData((prev) => ({ ...prev, phone: value }))}
            placeholder="(555) 555-5555"
            inputHeight="h-8"
          />
          <div />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9.5">
          <TextInput
            label="Email"
            name="email"
            value={contactData.email}
            setValue={(value) => setContactData((prev) => ({ ...prev, email: value }))}
            placeholder="name@email.com"
            inputHeight="h-8"
          />
        </div>
      </div>
      <div className="space-y-5.5">
        <TextArea
          label="Note"
          name="note"
          value={contactData.note}
          setValue={(value) => setContactData((prev) => ({ ...prev, note: value }))}
          placeholder="enter notes"
          rows={2}
          className="resize-y py-1.5"
        />
      </div>

      <div className="border-b border-vamos-blue-gray my-8.5" />

      <h2 className="text-lg font-medium text-left pb-5.5">Address</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9.5 pb-5.5">
        <TextInput
          label="Address Line 1"
          name="address1"
          value={contactData.address1}
          setValue={(value) => setContactData((prev) => ({ ...prev, address1: value }))}
          placeholder="enter address line 1"
          inputHeight="h-8"
        />
        <TextInput
          label="Address Line 2"
          name="address2"
          value={contactData.address2}
          setValue={(value) => setContactData((prev) => ({ ...prev, address2: value }))}
          placeholder="enter address line 2"
          inputHeight="h-8"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9.5 gap-y-5.5">
        <TextInput
          label="City"
          name="city"
          value={contactData.city}
          setValue={(value) => setContactData((prev) => ({ ...prev, city: value }))}
          placeholder="enter city"
          inputHeight="h-8"
        />
        <CustomSelect
          options={SITE_STATES.map((state) => ({ label: state.name, value: state.name }))}
          label="State"
          name="state"
          spaceY="space-y-2"
          labelClassName="font-medium"
          value={contactData.state}
          shouldShowClearOption
          setValue={(opt) => setContactData((prev) => ({ ...prev, state: opt?.value ?? '' }))}
          placeholder="select state"
        />
        <TextInput
          label="ZIP"
          name="zip"
          value={contactData.zip_code}
          setValue={(value) => setContactData((prev) => ({ ...prev, zip_code: value }))}
          placeholder="enter ZIP"
          inputHeight="h-8"
        />
      </div>
    </main>
  );
};

MainInputs.propTypes = {
  contactData: PropTypes.object.isRequired,
  setContactData: PropTypes.func.isRequired,
  isNameValid: PropTypes.bool.isRequired,
  setIsNameValid: PropTypes.func.isRequired,
  errorMessage: PropTypes.object.isRequired,
};

export default MainInputs;
